module.exports = __webpack_public_path__ + "static/media/jabuticabeira_thumb.1cd8fbfa.jpg";